import React from 'react';

// Exports
// -------

export default function useInterval(delay = 1000) {
  const [intervalCount, setIntervalsCount] = React.useState(0);

  //
  // Side-Effects

  React.useEffect(() => {
    const intervalId = setInterval(() => {
      setIntervalsCount((intervalCount) => intervalCount + 1);
    }, delay);

    return function _cleanup() {
      clearInterval(intervalId);
    };
  }, [delay]);

  //
  // Result

  return intervalCount;
}
